/**
 * @author sban3308
 * */

/**
 * Action Types
 */
export const REQUEST_OVERAGE_FILE_IMPORT = 'REQUEST_OVERAGE_FILE_IMPORT';
export const RECEIVE_OVERAGE_FILE_IMPORT = 'RECEIVE_OVERAGE_FILE_IMPORT';
export const FETCH_EI_TERM_DETAILS = 'FETCH_EI_TERM_DETAILS';
export const RECEIVE_EI_TERM_DETAILS = 'RECEIVE_EI_TERM_DETAILS';
export const RESET_EI_TERM_DETAILS = 'RESET_EI_TERM_DETAILS';

/**
 * Actions
 */
export const requestOverageFileImport = (data) => ({ type: REQUEST_OVERAGE_FILE_IMPORT, data });
export const receiveOverageFileImport = (data) => ({ type: RECEIVE_OVERAGE_FILE_IMPORT, data });

export const fetchEiTermDetails = (data) => ({ type: FETCH_EI_TERM_DETAILS, data });
export const receiveEiTermDetails = (data) => ({ type: RECEIVE_EI_TERM_DETAILS, data });
export const resetEiTermData = () => ({ type: RESET_EI_TERM_DETAILS });
